import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/store';
import { safeRedirect } from '../helper/helper';

Vue.use(VueRouter)

import HomePage from './../views/HomePage'
import HistoryPage from './../views/history/HistoryPage'
import RequestsPage from '../views/requests/RequestsPage'
import ApprovalPage from '../views/approval/ApprovalPage'
import EquipmentsPage from '../views/equipments/EquipmentsPage'
import UsersPage from '../views/users/UsersPage'
import LoginPage from '../views/auth/LoginPage'
import NotFound from '../common/NotFound.vue'
import ProfileSettings from '../views/users/ProfileSettings.vue'
import HistoryDetails from '../views/history/HistoryDetails.vue'
import TeacherRequests from '../views/teacher/request/TeacherRequests.vue'
import TeacherRequestDetails from '../views/teacher/request/TeacherRequestDetails.vue'
import TeacherApprovalPage from '../views/teacher/approval/TeacherApprovalPage.vue'
import DecontarePage from '../views/decontare/DecontarePage.vue'
import ConfigurarePage from '../views/configurare/ConfigurarePage.vue'
import ItemCardPage from '../views/equipments/ItemCardPage.vue'
import { CONFIG_ROLES, ITEM_EDITOR_ROLES } from '@/config/periferice'


const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
    meta: { requiresAuth: true },
  },
  {
    path: '/history',
    name: 'history',
    component: HistoryPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/requests',
    name: 'requests',
    component: RequestsPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/approval',
    name: 'approval',
    component: ApprovalPage,
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      const isAuthenticated = isAuthenticatedMethod();
      const isUser = store.getters.getUser.role === "user";
      if (isAuthenticated && !isUser) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/equipments',
    name: 'eqhipments',
    component: EquipmentsPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/profile',
    name: 'profile',
    component: ProfileSettings,
    meta: { requiresAuth: true },
  },
  {
    path: '/history/:id',
    name: 'historyDetails',
    component: HistoryDetails,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/users',
    name: 'Users',
    component: UsersPage,
    meta: { requiresAuth: true, requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const isAuthenticated = isAuthenticatedMethod();
      const isAdmin = store.getters.getUser.role === "admin";
      const isEngineer = store.getters.getUser.role === "inginer";
      const isDtiSef = store.getters.getUser.role === "dtisef";
      const isEngineerPC = store.getters.getUser.role === "inginer-pc";
      const isOperator = store.getters.getUser.role === "operator";
      if (isAuthenticated && (isAdmin || isEngineer || isDtiSef || isEngineerPC || isOperator)) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    meta: { requiresAuth: false },
  },

  {
    path: '/teacher-requests',
    name: 'TeacherRequests',
    component: TeacherRequests,
    meta: { requiresAuth: true }
  },
  {
    path: '/teacher-request-details/:requestId',
    name: 'TeacherRequestDetails',
    component: TeacherRequestDetails,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/teacher-approvals',
    name: 'TeacherApproval',
    component: TeacherApprovalPage,
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      const isAuthenticated = isAuthenticatedMethod();
      const isAdmin = store.getters.getUser.role === "admin";
      const isRector = store.getters.getUser.role === "rector";
      const isDean = store.getters.getUser.role === "usersef";
      const isOperator = store.getters.getUser.role === "operator";
      if (isAuthenticated && (isAdmin || isRector || isDean || isOperator)) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/decontare',
    name: 'decontare',
    component: DecontarePage,
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      const isAuthenticated = isAuthenticatedMethod();
      const role = store.getters.getUser.role;
      const allowed = ['admin', 'inginer', 'inginer-pc', 'dtisef'];
      if (isAuthenticated && allowed.includes(role)) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/configurare',
    name: 'configurare',
    component: ConfigurarePage,
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      const isAuthenticated = isAuthenticatedMethod();
      const role = (store.getters.getUser || {}).role;
      if (isAuthenticated && CONFIG_ROLES.includes(role)) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    // many devices in a row from a phone; the equipment managers (server EQUIPMENT_MANAGERS)
    path: '/inventariere',
    name: 'inventariere',
    component: () => import(/* webpackChunkName: "inventariere" */ '../views/inventariere/InventarierePage.vue'),
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      const role = (store.getters.getUser || {}).role;
      if (isAuthenticatedMethod() && ITEM_EDITOR_ROLES.includes(role)) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    // the QR sticker of an item (https://suport.usarb.md/e/<tag>): every logged-in role; not logged in -> login -> back here
    path: '/e/:tag',
    name: 'itemCard',
    component: ItemCardPage,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '*',
    name: 'Not Found',
    component: NotFound,
    beforeEnter: (to, from, next) => {
      const isAuthenticated = isAuthenticatedMethod();
      if (isAuthenticated) {
        next();
      } else {
        next(loginRoute(to));
      }
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticatedMethod()) {
    next(loginRoute(to));
  } else {
    next();
  }
});

// the login page sends the person back where they were going (e.g. the item behind a scanned QR sticker)
function loginRoute(to) {
  const back = safeRedirect(to && to.fullPath);
  return back !== '/' ? { path: '/login', query: { redirect: back } } : '/login';
}

function isAuthenticatedMethod() {
  const token = localStorage.getItem("token");
  return token !== null && token !== undefined;
}

export default router;
